import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useFormControlStyles = makeStyles((_theme: Theme) => ({
  formElements: {
    width: '100%',
    height: '100%',
    display: 'flex-inline',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginBottom: '8px',
  },
  formControlLabel: {
    marginLeft: 0,
    marginBottom: 4,
  },
  formElementStyle: {
    width: '100%',
  },
  formElementsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2em',
    width: '100%',
  },
  form: {
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'spaceEvenly',
    alignItems: 'start',
    paddingRight: '18px',
    paddingLeft: '18px',
  },
  formInput: {
    marginBottom: '18px',
  },
}));

export default useFormControlStyles;
